import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=032c80fc&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=js&"
export * from "./Mask.vue?vue&type=script&lang=js&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=032c80fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c80fc",
  null
  
)

export default component.exports